/**
 * The portal's bottom sheet: slides up from the thumb end of the screen, dims
 * the page behind it, closes on the backdrop, the × button or Escape. Focus,
 * Escape and the scroll lock are PortalModal's (@restart/ui).
 *
 * `closeLabel` names the × and the backdrop for a screen reader: Hungarian
 * on the driver screens (the default), "Close" on the English operator ones.
 */
import React, { useId } from 'react';
import PortalModal from './PortalModal';
import { CloseIcon } from './Icons';

export default function BottomSheet({
  title, subtitle = '', onClose, closeDisabled = false, closeLabel = 'Bezárás', children,
}) {
  const titleId = useId();

  return (
    <PortalModal
      className="pp-sheet"
      backdropClassName="pp-sheet__backdrop"
      labelledBy={titleId}
      onHide={onClose}
      closable={!closeDisabled}
      closeLabel={closeLabel}
    >
      <div className="pp-sheet__grip" aria-hidden="true" />
      <div className="pp-sheet__head">
        <div className="pp-sheet__heading">
          <h2 className="pp-sheet__title" id={titleId}>{title}</h2>
          {subtitle ? <div className="pp-sheet__subtitle">{subtitle}</div> : null}
        </div>
        <button
          type="button"
          className="pp-sheet__close"
          aria-label={closeLabel}
          onClick={onClose}
          disabled={closeDisabled}
        >
          <CloseIcon size={20} />
        </button>
      </div>
      <div className="pp-sheet__body">{children}</div>
    </PortalModal>
  );
}
